module.exports = __webpack_public_path__ + "7f6d04b6bc5cb145480a8dafd5416529.jpg";